// extracted by mini-css-extract-plugin
module.exports = {"button":"googleButton_button__PWlnl","buttonLogo":"googleButton_buttonLogo__Yo_Nf","buttonLabel":"googleButton_buttonLabel__o_2XG"};